<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end">
        <el-col>
          <download-excel
            class="filter-item"
            :fields="json_fields"
            :fetch="handleExport"
            type="xls"
            name="数据统计.xls"
            worksheet="数据统计"
          >
            <el-button size="small" type="success" :loading="exportLoading">
              导出数据统计
            </el-button>
          </download-excel>
          <!-- <el-button
            class="filter-item"
            type="primary"
            @click="downloadExcel"
            size="small"
          >
            下载发放用户模板
          </el-button> -->
          <el-button
            size="small"
            class="filter-item"
            type="primary"
            @click="addLog"
            >新增发放
          </el-button>
        </el-col>
        <div
          class="px-10 text-nowtap"
          style="height: auto; display: flex; align-items: center"
        >
          发放时间
        </div>
        <div class="m-r-5">
          <el-date-picker
            size="small"
            v-model="listQuery.date"
            type="datetimerange"
            @change="changedata"
            format="yyyy 年 MM 月 dd 日 hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <el-button
          size="small"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索
        </el-button>
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间">
        <template slot-scope="scope">
          {{ scope.row.start_date }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间">
        <template slot-scope="scope">
          {{ scope.row.end_date }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="营业额">
        <template slot-scope="scope">
          {{ scope.row.sales }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="奖励值">
        <template slot-scope="scope">
          {{ scope.row.reward_value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="发放人数">
        <template slot-scope="scope">
          {{ scope.row.user_num }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="本次每份额金额 ($)" width="140">
        <template slot-scope="scope">
          {{ scope.row.share_reward_value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="发放时间" width="160">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'none'" type="">
            {{ status(scope.row.status) }}
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'revoked'" type="danger">
            {{ status(scope.row.status) }}
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'completed'" type="success">
            {{ status(scope.row.status) }}
          </el-tag>
          <el-tag v-else type="warning">
            {{ status(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="130"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <download-excel
            v-if="scope.row.status != 'none'"
            class="filter-item"
            :fields="json_fields2"
            :fetch="handleExport2"
            type="xls"
            name="数据统计.xls"
            worksheet="数据统计"
          >
            <el-button
              size="mini"
              type="success"
              :loading="scope.row.exportLoading"
              @click="before(scope.row)"
            >
              导出发放Excel
            </el-button>
          </download-excel>
          <!-- <el-button
            v-if="scope.row.user_num <= 0 && scope.row.status != 'completed'"
            style="margin-top: 5px"
            size="small"
            class="filter-item"
            type="primary"
            @click="addLog(scope.row)"
            >新增发放
          </el-button> -->
          <div style="margin-top: 5px">
            <el-button
              v-if="scope.row.status == 'completed'"
              size="mini"
              type="warning"
              @click="revoke(scope.row)"
            >
              撤销发放
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="新增创始人分红发放"
      :visible.sync="showaddLog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="700px"
    >
      <!-- 步骤指示器 -->
      <el-steps
        :active="currentStep"
        finish-status="success"
        simple
        style="margin-bottom: 20px"
      >
        <el-step title="上传名单" />
        <el-step title="配置参数" />
        <el-step title="核对摘要" />
      </el-steps>

      <!-- 第一步：上传名单 -->
      <div v-if="currentStep === 0">
        <div style="text-align: center; margin-bottom: 20px">
          <h3>第一步：上传核对后的分红名单文件</h3>
          <!-- <p style="color: #909399; font-size: 14px; margin-top: 5px">
            支持 .xlsx 或 .csv 格式，支持点击选择文件或拖拽上传
          </p> -->
          <el-alert
            title="支持 .xlsx 或 .csv 格式，支持点击选择文件或拖拽上传"
            type="info"
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>

        <el-upload
          class="upload-demo"
          drag
          action=""
          accept=".xlsx,.xls,.csv"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleImportUsers"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip">
            支持 .xlsx 或 .csv 格式，文件大小不超过 10MB
          </div>
        </el-upload>

        <div style="margin-top: 20px; text-align: center">
          <el-button type="text" @click="downloadExcel" icon="el-icon-download">
            下载标准模板
          </el-button>
        </div>

        <div v-if="addLogform.users.length > 0" style="margin-top: 20px">
          <el-alert
            title="文件解析成功"
            type="success"
            :closable="false"
            show-icon
            style="margin-bottom: 15px"
          >
            <span>已成功解析 {{ addLogform.users.length }} 条记录</span>
          </el-alert>

          <el-table
            :data="paginatedUsers"
            border
            size="small"
            style="width: 100%"
            v-loading="filterloading"
            height="240"
          >
            <el-table-column prop="uuid" label="UUID" width="80" />
            <el-table-column prop="username" label="用户名称" />
            <el-table-column prop="share" label="分红份额" width="100" />
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  :disabled="!scope.row.remark || scope.row.remark.length <= 20"
                >
                  <div style="max-width: 200px" slot="content">
                    {{ scope.row.remark || '-' }}
                  </div>
                  <span class="remark-cell">
                    {{
                      scope.row.remark
                        ? scope.row.remark.length > 20
                          ? scope.row.remark.substring(0, 20) + '...'
                          : scope.row.remark
                        : '-'
                    }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="会员状态" width="120">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.vip_status === 'active'"
                  type="success"
                  size="small"
                >
                  VIP已激活
                </el-tag>
                <el-tag
                  v-else-if="scope.row.vip_status === 'inactive'"
                  type="info"
                  size="small"
                >
                  VIP未激活
                </el-tag>
                <el-tag
                  v-else-if="scope.row.vip_status === 'inactive_affiliate'"
                  type="info"
                  size="small"
                >
                  VIP未激活-网红
                </el-tag>
                <el-tag
                  v-else-if="scope.row.vip_status === 'never_purchased'"
                  type="info"
                  size="small"
                >
                  非VIP
                </el-tag>
                <el-tag v-else type="danger" size="small"> 无效UUID </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px; text-align: right">
            <el-pagination
              @size-change="handlePreviewSizeChange"
              @current-change="handlePreviewCurrentChange"
              :current-page="previewPagination.page"
              :page-sizes="previewPagination.pageSizes"
              :page-size="previewPagination.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="filteredUsers.length"
              small
            >
            </el-pagination>
          </div>
          <!-- <div
            v-if="addLogform.users.length > 5"
            style="text-align: center; margin-top: 10px"
          >
            <el-tag type="info"
              >... 还有 {{ addLogform.users.length - 5 }} 条记录未显示</el-tag
            >
          </div> -->
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button @click="showaddLog = false">取消</el-button>
          <el-button
            type="primary"
            @click="currentStep = 1"
            :disabled="addLogform.users.length === 0"
          >
            下一步
          </el-button>
        </div>
      </div>

      <!-- 第二步：配置参数 -->
      <div v-if="currentStep === 1">
        <div style="text-align: center; margin-bottom: 20px">
          <h3>第二步：配置发放参数</h3>
        </div>

        <el-form
          ref="configForm"
          :model="configForm"
          :rules="configRules"
          label-width="160px"
          size="small"
        >
          <!-- 发放区间 -->
          <el-form-item label="本次发放区间：" prop="dateRange">
            <el-date-picker
              v-model="configForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @change="handleDateRangeChange"
            />
          </el-form-item>

          <!-- 每份额金额 -->
          <el-form-item label="本次每份额金额 ($)：" prop="shareAmount">
            <el-input
              v-model="configForm.shareAmount"
              placeholder="请输入每一份 Share 对应的美金金额"
              style="width: 200px"
            >
              <template slot="append">$</template>
            </el-input>
            <div style="color: #909399; font-size: 12px; margin-top: 5px">
              支持两位小数，例如：10.50
            </div>
          </el-form-item>

          <!-- 过滤开关 -->
          <el-form-item label="仅展示活跃会员：">
            <el-switch
              v-model="filterInactiveVIP"
              @change="filterVIP"
              active-color="#13ce66"
            />
            <div style="color: #909399; font-size: 12px; margin-top: 5px">
              开启后仅显示 VIP 状态为"活跃"的会员
            </div>
          </el-form-item>
        </el-form>

        <!-- 用户列表预览 -->
        <div style="margin-top: 20px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
            "
          >
            <span>用户名单预览 ({{ filteredUsers.length }} 人)</span>
            <el-tag type="info" size="small">
              总计份额: {{ totalShares }} 份
            </el-tag>
          </div>

          <div
            style="
              height: 300px;
              overflow-y: auto;
              border: 1px solid #ebeef5;
              border-radius: 4px;
              padding: 10px;
            "
          >
            <el-table
              :data="paginatedUsers"
              size="mini"
              border
              style="width: 100%"
              height="240"
            >
              <el-table-column prop="uuid" label="UUID" width="80" />
              <el-table-column prop="username" label="用户名称" width="100" />
              <el-table-column prop="remark" label="备注">
                <template slot-scope="scope">
                  <el-tooltip
                    placement="top"
                    :disabled="
                      !scope.row.remark || scope.row.remark.length <= 20
                    "
                  >
                    <div style="max-width: 200px" slot="content">
                      {{ scope.row.remark || '-' }}
                    </div>
                    <span class="remark-cell">
                      {{
                        scope.row.remark
                          ? scope.row.remark.length > 20
                            ? scope.row.remark.substring(0, 20) + '...'
                            : scope.row.remark
                          : '-'
                      }}
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="share"
                label="分红份额"
                align="right"
                width="100"
              />
              <el-table-column label="预计金额 ($)" align="right" width="100">
                <template slot-scope="scope">
                  {{ calculateUserAmount(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="状态" width="120">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.vip_status === 'active'"
                    type="success"
                    size="small"
                  >
                    VIP已激活
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.vip_status === 'inactive'"
                    type="info"
                    size="small"
                  >
                    VIP未激活
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.vip_status === 'inactive_affiliate'"
                    type="info"
                    size="small"
                  >
                    VIP未激活-网红
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.vip_status === 'never_purchased'"
                    type="info"
                    size="small"
                  >
                    非VIP
                  </el-tag>
                  <el-tag v-else type="danger" size="small"> 无效UUID </el-tag>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div style="margin-top: 10px; text-align: right">
              <el-pagination
                @size-change="handlePreviewSizeChange"
                @current-change="handlePreviewCurrentChange"
                :current-page="previewPagination.page"
                :page-sizes="previewPagination.pageSizes"
                :page-size="previewPagination.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="filteredUsers.length"
                small
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button @click="currentStep = 0">上一步</el-button>
          <el-button
            type="primary"
            @click="currentChangeStep2"
            :disabled="!isStep2Valid"
          >
            下一步
          </el-button>
        </div>
      </div>

      <!-- 第三步：核对摘要 -->
      <div v-if="currentStep === 2">
        <div style="text-align: center; margin-bottom: 20px">
          <h3>第三步：核对发放摘要</h3>
          <p style="color: #909399; font-size: 14px; margin-top: 5px">
            请仔细核对以下信息，确认无误后提交
          </p>
        </div>

        <div
          style="
            background: #f8f9fa;
            padding: 20px;
            border-radius: 4px;
            margin-bottom: 20px;
          "
        >
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="发放区间">
              {{
                configForm.dateRange
                  ? configForm.dateRange.join(' 至 ')
                  : '未设置'
              }}
            </el-descriptions-item>
            <el-descriptions-item label="涉及人数">
              {{ filteredUsers.length }} 人
              <el-tag
                v-if="filterInactiveVIP"
                type="success"
                size="mini"
                style="margin-left: 10px"
              >
                已过滤非活跃会员
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="本次每份额金额">
              ${{ configForm.shareAmount || '0.00' }}
            </el-descriptions-item>
            <el-descriptions-item label="预计发放总额">
              <span style="font-size: 18px; color: #e6a23c; font-weight: bold">
                ${{ totalAmount.toFixed(2) }}
              </span>
              <div style="color: #909399; font-size: 12px; margin-top: 5px">
                计算公式：总份额 {{ totalShares }} × 每份额 ${{
                  configForm.shareAmount || '0.00'
                }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 详细列表 -->
        <div style="margin-top: 20px">
          <el-collapse>
            <el-collapse-item title="查看详细发放列表">
              <el-table
                :data="paginatedUsers"
                size="small"
                border
                style="width: 100%"
                height="240"
              >
                <el-table-column prop="uuid" label="UUID" width="80" />
                <el-table-column prop="username" label="用户名称" />
                <el-table-column
                  prop="share"
                  label="分红份额"
                  width="100"
                  align="right"
                />
                <el-table-column label="发放金额 ($)" width="100" align="right">
                  <template slot-scope="scope">
                    {{ calculateUserAmount(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                  <template slot-scope="scope">
                    <el-tooltip
                      placement="top"
                      :disabled="
                        !scope.row.remark || scope.row.remark.length <= 20
                      "
                    >
                      <div style="max-width: 200px" slot="content">
                        {{ scope.row.remark || '-' }}
                      </div>
                      <span class="remark-cell">
                        {{
                          scope.row.remark
                            ? scope.row.remark.length > 20
                              ? scope.row.remark.substring(0, 20) + '...'
                              : scope.row.remark
                            : '-'
                        }}
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="会员状态" width="120">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.vip_status === 'active'"
                      type="success"
                      size="small"
                    >
                      VIP已激活
                    </el-tag>
                    <el-tag
                      v-else-if="scope.row.vip_status === 'inactive'"
                      type="info"
                      size="small"
                    >
                      VIP未激活
                    </el-tag>
                    <el-tag
                      v-else-if="scope.row.vip_status === 'inactive_affiliate'"
                      type="info"
                      size="small"
                    >
                      VIP未激活-网红
                    </el-tag>
                    <el-tag
                      v-else-if="scope.row.vip_status === 'never_purchased'"
                      type="info"
                      size="small"
                    >
                      非VIP
                    </el-tag>
                    <el-tag v-else type="danger" size="small">
                      无效UUID
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页组件 -->
              <div style="margin-top: 10px; text-align: right">
                <el-pagination
                  @size-change="handlePreviewSizeChange"
                  @current-change="handlePreviewCurrentChange"
                  :current-page="previewPagination.page"
                  :page-sizes="previewPagination.pageSizes"
                  :page-size="previewPagination.pageSize"
                  layout="total, sizes, prev, pager, next"
                  :total="filteredUsers.length"
                  small
                >
                </el-pagination>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button @click="currentStep = 1">上一步</el-button>
          <el-button @click="showaddLog = false">取消</el-button>
          <el-button type="primary" @click="postaddLog" :loading="btnLoading">
            确认发放
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
import { excel2Json } from '@/utils/excel'

export default {
  components: { downloadExcel },
  data() {
    return {
      btnLoading: false,
      showaddLog: false,
      currentStep: 0, // 当前步骤：1-上传，2-配置，3-核对
      addLogRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      configRules: {
        dateRange: [
          { required: true, message: '请选择发放区间', trigger: 'change' },
        ],
        shareAmount: [
          { required: true, message: '请输入每份额金额', trigger: 'blur' },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: '请输入有效的金额（支持两位小数）',
            trigger: 'blur',
          },
        ],
      },
      filterInactiveVIP: false,
      filterloading: false,
      addLogform: {
        users: [],
        date: '',
        start_date: '',
        end_date: '',
      },
      configForm: {
        dateRange: [],
        shareAmount: '',
      },
      allImportedUsers: [], // 新增：保存所有导入的用户数据
      // 分页相关数据
      previewPagination: {
        page: 1,
        pageSize: 10,
        pageSizes: [10, 30, 50, 100],
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: '',
        end_at: '',
      },
      userLogsid: '',
      viplist: [],
      json_fields: {
        发放人数: {
          field: 'user_num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        发放时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
      json_fields2: {
        用户名称: {
          field: 'username',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        姓: {
          field: 'last_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        名: {
          field: 'first_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户id: {
          field: 'user_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        奖励金额: {
          field: 'reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        分红份额: {
          field: 'vip_level_share',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              parseInt(value) +
              '</p>'
            )
          },
        },
        备注: {
          field: 'remark',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    showaddLog(newVal) {
      if (newVal) {
        // 打开弹窗时重置所有状态
        this.currentStep = 0
        this.addLogform = {
          users: [],
          date: '',
          start_date: '',
          end_date: '',
          global_reward_log_id: this.addLogform.global_reward_log_id,
        }
        this.configForm = {
          dateRange: [],
          shareAmount: '',
        }
        this.allImportedUsers = []
        this.filterInactiveVIP = false
        // 重置分页
        this.previewPagination.page = 1
        this.previewPagination.pageSize = 10
      }
    },
  },
  computed: {
    switchDisabled() {
      return this.addLogform.users.length <= 0
    },
    // 过滤后的用户列表
    filteredUsers() {
      if (this.filterInactiveVIP) {
        return this.addLogform.users.filter(
          (user) => user.vip_status === 'active',
        )
      }
      return this.addLogform.users
    },
    // 总份额
    totalShares() {
      return this.filteredUsers.reduce((sum, user) => {
        const share = parseInt(user.share) || 0
        return sum + share
      }, 0)
    },
    // 总金额
    totalAmount() {
      const shareAmount = parseFloat(this.configForm.shareAmount) || 0
      return this.totalShares * shareAmount
    },
    // 第二步是否有效
    isStep2Valid() {
      return (
        this.configForm.dateRange &&
        this.configForm.dateRange.length === 2 &&
        this.configForm.shareAmount &&
        parseFloat(this.configForm.shareAmount) > 0
      )
    },
    // 分页后的用户数据
    paginatedUsers() {
      const start =
        (this.previewPagination.page - 1) * this.previewPagination.pageSize
      const end = start + this.previewPagination.pageSize
      return this.filteredUsers.slice(start, end)
    },
    //状态：none：未处理 ； pending：处理中 ；completed：已完成； revoke_pending ：撤销处理中；revoked：已撤销
    status() {
      return (val) => {
        switch (val) {
          case 'none':
            return '未处理'
          case 'pending':
            return '处理中'
          case 'completed':
            return '已完成'
          case 'revoke_pending':
            return '撤销处理中'
          case 'revoked':
            return '已撤销'
        }
      }
    },
  },
  methods: {
    currentChangeStep2() {
      if (this.filteredUsers.length > 1500) {
        return this.$message.warning('创始人分红人数上限：1500人')
      }
      this.currentStep = 2
    },
    // 计算单个用户金额
    calculateUserAmount(user) {
      const share = parseInt(user.share) || 0
      const shareAmount = parseFloat(this.configForm.shareAmount) || 0
      return (share * shareAmount).toFixed(2)
    },
    // 处理日期范围变化
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.addLogform.start_date = val[0]
        this.addLogform.end_date = val[1]
      } else {
        this.addLogform.start_date = ''
        this.addLogform.end_date = ''
      }
    },
    // 分页大小改变
    handlePreviewSizeChange(val) {
      this.previewPagination.pageSize = val
      this.previewPagination.page = 1
    },
    // 当前页改变
    handlePreviewCurrentChange(val) {
      this.previewPagination.page = val
    },
    // 文件上传前的验证
    beforeUpload(file) {
      const isExcel =
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls') ||
        file.name.endsWith('.csv')
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 .xlsx、.xls 或 .csv 格式的文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },
    filterVIP(e) {
      console.log(e)
      // 重置分页
      this.previewPagination.page = 1
      if (e && this.addLogform.users.length > 0) {
        this.filterByUUID()
      } else {
        this.addLogform.users = this.allImportedUsers
      }
    },
    filterByUUID() {
      if (this.addLogform.users.length <= 0) return

      this.filterloading = true
      request({
        url: '/api/backend/users/getUserByUUID',
        method: 'post',
        data: {
          ids: this.addLogform.users.map((item) => item.uuid),
        },
      })
        .then((res) => {
          console.log(res)
          // 创建一个映射，将 uuid 映射到用户数据（包括 vip_status）
          const userMap = new Map()
          if (res.data && res.data.length > 0) {
            res.data.forEach((user) => {
              userMap.set(user.uuid, user)
            })
          }

          // 更新所有导入的用户，添加 vip_status 字段
          const updatedUsers = this.addLogform.users.map((user) => {
            const serverUser = userMap.get(user.uuid)
            return {
              ...user,
              vip_status: serverUser ? serverUser.vip_status : 'unknown',
              // 保留服务器返回的其他字段，如果有的话
              ...(serverUser || {}),
            }
          })

          // 同时更新 allImportedUsers 以保持数据同步
          this.allImportedUsers = this.allImportedUsers.map((user) => {
            const serverUser = userMap.get(user.uuid)
            return {
              ...user,
              vip_status: serverUser ? serverUser.vip_status : 'unknown',
              ...(serverUser || {}),
            }
          })

          // 如果开启了过滤非活跃VIP，则过滤掉非活跃用户
          // 保留 active 状态和 unknown（UUID不存在）的用户
          if (this.filterInactiveVIP) {
            this.addLogform.users = updatedUsers.filter((user) => {
              // 保留 active 状态和 unknown（UUID不存在）的用户
              return user.vip_status === 'active'
            })
          } else {
            this.addLogform.users = updatedUsers
          }

          this.filterloading = false
        })
        .catch(() => {
          this.filterloading = false
        })
    },
    before(row) {
      console.log(row)
      row.exportLoading = true
      this.userLogsid = row.id
    },
    addLog(row) {
      // if (row.sales <= 0) {
      //   return this.$message.warning(
      //     '本季度相关营业额为0，请重新调整后再进行发放。',
      //   )
      // }
      this.showaddLog = true
      this.currentStep = 0
      this.addLogform.users = []
      this.allImportedUsers = []
      this.configForm.dateRange = []
      this.configForm.shareAmount = ''
      this.filterInactiveVIP = false
      // 重置分页
      this.previewPagination.page = 1
      this.previewPagination.pageSize = 10
      // this.addLogform.global_reward_log_id = row.id
    },
    downloadExcel() {
      let a = document.createElement('a')
      a.href = '/发放用户模板.xlsx'
      a.download = '发放用户模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    postaddLog() {
      // 验证表单
      if (
        !this.configForm.dateRange ||
        this.configForm.dateRange.length !== 2
      ) {
        return this.$message.warning('请选择发放区间')
      }
      if (
        !this.configForm.shareAmount ||
        parseFloat(this.configForm.shareAmount) <= 0
      ) {
        return this.$message.warning('请输入有效的每份额金额')
      }
      if (this.filteredUsers.length <= 0) {
        return this.$message.warning('没有有效的发放用户')
      }
      if (
        this.filteredUsers.filter((item) => item.vip_status === 'unknown')
          .length > 0
      ) {
        return this.$message.warning('存在无效UUID的用户，请检查UUID是否正确')
      }

      // 准备提交数据
      const submitData = {
        ...this.addLogform,
        start_date: this.addLogform.start_date || this.configForm.dateRange[0],
        end_date: this.addLogform.end_date || this.configForm.dateRange[1],
        users: this.filteredUsers, // 使用过滤后的用户列表
        share_reward_value: parseFloat(this.configForm.shareAmount),
        total_amount: this.totalAmount,
        total_users: this.filteredUsers.length,
        total_shares: this.totalShares,
      }

      this.btnLoading = true
      return request({
        url: '/api/backend/globalReward/addLog',
        method: 'POST',
        data: submitData,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '发放成功',
            })
            this.showaddLog = false
            this.getList()
          } else {
            this.$message.error(res.message || '发放失败')
          }
        })
        .catch((error) => {
          console.error('发放失败:', error)
          this.$message.error('发放失败，请稍后重试')
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    handleImportUsers(file) {
      this.addLogform.users = []
      this.allImportedUsers = [] // 清空历史导入数据，只保留当前批次
      file = file.raw

      if (!this.beforeUpload(file)) {
        return
      }

      excel2Json(file, 1)
        .then((excelData) => {
          console.log(excelData)
          // 处理业务
          if (excelData.length <= 0) {
            this.$message.error('数据不能为空')
            return
          }
          if (excelData.length > 1500) {
            this.$message.error('一次只能上传1500条数据')
            return
          }

          // 验证数据格式
          const validData = []
          const invalidRows = []

          excelData.forEach((element, index) => {
            // 检查必需字段
            if (element['UUID'] === undefined || element['UUID'] === null) {
              invalidRows.push(index + 1)
              return
            }

            const share = parseInt(element['分红份额'] || 0)
            // if (isNaN(share) || share < 1) {
            //   invalidRows.push(index + 1)
            //   return
            // }

            validData.push({
              uuid: String(element['UUID']).trim(),
              username: String(element['用户名称'] || '-').trim(),
              share: share,
              remark: element['备注'] ? String(element['备注']).trim() : '',
            })
          })

          if (invalidRows.length > 0) {
            this.$message({
              message: `第 ${invalidRows.join(', ')} 行数据格式不正确，已跳过`,
              type: 'warning',
            })
          }

          if (validData.length === 0) {
            this.$message({
              message: '没有有效的用户数据',
              type: 'error',
            })
            return
          }

          // 添加到表单
          validData.forEach((item) => {
            this.addLogform.users.push({
              ...item,
              vip_status: 'unknown', // 初始状态，等待API查询
            })
            this.allImportedUsers.push({
              ...item,
              vip_status: 'unknown',
            })
          })

          // 查询用户状态
          this.filterByUUID()

          this.$message.success(`成功导入 ${validData.length} 条用户数据`)
          console.log(this.addLogform.users, '=============')
        })
        .catch((error) => {
          console.error('Excel解析错误:', error)
          this.$message.error('文件解析失败，请检查文件格式')
        })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0]
        this.listQuery.end_at = val[1]
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    changeaddLogformdata(val) {
      console.log(val)
      if (val) {
        this.addLogform.start_date = val[0]
        this.addLogform.end_date = val[1]
      } else {
        this.addLogform.start_date = ''
        this.addLogform.end_date = ''
      }
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/globalReward/logs',
        method: 'get',
        params: {
          ...listQuery,
          page: 1,
          limit: 100000,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    handleExport2() {
      this.exportLoading = true
      return request({
        url: '/api/backend/globalReward/userLogs',
        method: 'get',
        params: {
          page: 1,
          limit: 100000,
          id: this.userLogsid,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
          this.list = this.list.map((item) => {
            return {
              ...item,
              exportLoading: false,
            }
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/globalReward/logs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data.map((item) => {
          return {
            ...item,
            exportLoading: false,
          }
        })
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    revoke(row) {
      this.$confirm('是否确认撤销？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/globalReward/revoke',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.upload-demo {
  width: 100%;

  ::v-deep .el-upload {
    width: 100% !important;
    height: 300px;
  }
  ::v-deep .el-upload-dragger {
    width: 100% !important;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
